import styled from 'styled-components';

const ListWrapper = styled.div`
  background-color: #222222;
  border-bottom: 1px solid #999999;
  box-shadow: inset 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  padding: 10px 5%;
`;
export default ListWrapper;
